import axios from 'axios';
import { getEnvConfig } from '../constants';

export const setApiDefaults = () => {
  axios.defaults.baseURL = getEnvConfig().api;
  axios.defaults.withCredentials = true;
};
